import {
  GiftSubmissionBodyDto,
  GiftSubmissionBodyDtoFrequency,
  GiftSubmissionBodyDtoOccasion
} from '@portal-middleware/hooks';
import { WizardConfig } from '@vestwell-frontend/ui';

import { routes } from '../routes';

export const OccasionTextValues = {
  [GiftSubmissionBodyDtoOccasion['just-because']]: 'Just because',
  [GiftSubmissionBodyDtoOccasion.congratulations]: 'Congratulations',
  [GiftSubmissionBodyDtoOccasion.birthday]: 'Birthday',
  [GiftSubmissionBodyDtoOccasion.holiday]: 'Holiday',
  [GiftSubmissionBodyDtoOccasion['get-well']]: 'Get well',
  [GiftSubmissionBodyDtoOccasion.graduation]: 'Graduation'
};

export const FrequnceyTextValues = {
  [GiftSubmissionBodyDtoFrequency.monthly]: 'Monthly',
  [GiftSubmissionBodyDtoFrequency.biMonthly]: 'Twice a month',
  [GiftSubmissionBodyDtoFrequency.yearly]: 'Annually'
};

export const FrequnceyTextValuesForReviewPage = {
  [GiftSubmissionBodyDtoFrequency.monthly]: 'Monthly',
  [GiftSubmissionBodyDtoFrequency.biMonthly]: 'Monthly',
  [GiftSubmissionBodyDtoFrequency.yearly]: 'Annually'
};

export enum GiftStepState {
  start = 'start',
  occasion = 'occasion',
  info = 'info',
  password = 'password',
  bank = 'bank',
  review = 'review',
  success = 'success'
}

export type CreateGiftState = {
  stepState: GiftStepState;
  isAuthenticated: boolean;
  isCustomAmount: boolean;
  createProfile: boolean;
  giftSubmission: GiftSubmissionBodyDto;
  giftAccountId?: string;
  planId?: string;
};

export const createGiftState: WizardConfig<CreateGiftState> = {
  initialState: {
    createProfile: true,
    giftSubmission: {
      isRecurring: false,
      payment: {}
    },
    isAuthenticated: false,
    isCustomAmount: false,
    stepState: GiftStepState.start
  },
  steps: [
    {
      title: 'Start',
      url: routes.GiftingPublicStartPage,
      when: state => state.stepState === GiftStepState.start
    },
    {
      caption: 'Step 1 / 4',
      subTitle: "What's the occasion?",
      title: 'Occasion',
      url: routes.GiftingPublicOccasionPage,
      when: state => state.stepState === GiftStepState.occasion
    },
    {
      caption: 'Step 2 / 4',
      subTitle: 'Your information',
      title: 'Your information',
      url: routes.GiftingPublicInfoPage,
      when: state =>
        (state.stepState === GiftStepState.info &&
          !state.createProfile &&
          !state.isAuthenticated) ||
        (state.createProfile &&
          !state.giftSubmission?.contributor?.giftContributorId &&
          state.stepState === GiftStepState.info)
    },
    {
      caption: 'Step 2 / 4',
      subTitle: 'Create a password for your gifting profile',
      title: 'Create gifting profile',
      url: routes.GiftingPasswordPage,
      when: state =>
        state.createProfile &&
        !state.giftSubmission?.contributor?.giftContributorId &&
        state.stepState === GiftStepState.password
    },
    {
      caption: 'Step 3 / 4',
      subTitle: 'Payment method',
      title: 'Payment method',
      url: routes.GiftingPublicBankPage,
      when: state => state.stepState === GiftStepState.bank
    },
    {
      caption: 'Step 4 / 4',
      subTitle: 'Review your gift',
      title: 'Confirm gift',
      url: routes.GiftingReviewPage,
      when: state => state.stepState === GiftStepState.review
    },
    {
      title: 'Success',
      url: routes.GiftingSuccessPage,
      when: state => state.stepState === GiftStepState.success
    }
  ]
};

export const configCreateGiftStateWithUrlParams = (planId, giftingId) => {
  const updatedSteps = createGiftState.steps.map(step => ({
    ...step,
    url: step.url.replace(':planId', planId).replace(':giftingId', giftingId)
  }));

  const updatedCreateGiftState = {
    ...createGiftState,
    steps: updatedSteps
  };
  return updatedCreateGiftState;
};

export const configCreateGiftStateWithLoggedInUserParams = (
  planId,
  giftingId,
  giftContributorId
) => {
  const updatedSteps = createGiftState.steps.map(step => ({
    ...step,
    url: step.url
      .replace('/gifting', `/gifting/account`)
      .replace(':giftingId', giftingId)
      .replace(':planId', planId)
  }));

  const updatedCreateGiftState = {
    ...createGiftState,
    initialState: {
      ...createGiftState.initialState,
      createProfile: false,
      giftSubmission: {
        ...createGiftState.initialState.giftSubmission,
        contributor: {
          giftContributorId
        }
      },
      isAuthenticated: true
    },
    steps: updatedSteps
  };
  return updatedCreateGiftState;
};
